import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import type { PaginationMeta } from "@/types/common";
import type { UsePaginationReturn } from "@/hooks/use-pagination";

interface Props {
  meta: PaginationMeta;
  pagination: UsePaginationReturn;
}

export function ChatFeedbackPagination({ meta, pagination }: Props) {
  const rangeStart = (meta.currentPage - 1) * meta.limit + 1;
  const rangeEnd = Math.min(meta.currentPage * meta.limit, meta.totalCount);

  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <p className="text-sm text-muted-foreground text-center md:text-left">
        <span className="hidden md:inline">
          {meta.totalCount.toLocaleString()}개 중{" "}
          {rangeStart.toLocaleString()} - {rangeEnd.toLocaleString()}
        </span>
        <span className="md:hidden">
          {rangeStart}-{rangeEnd} / {meta.totalCount.toLocaleString()}
        </span>
      </p>
      <div className="flex items-center justify-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={pagination.prevPage}
          disabled={!meta.hasPrevPage}
          aria-label="Previous page"
          className="min-h-[44px] min-w-[44px] md:min-h-0 md:min-w-0"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <span className="text-sm min-w-[60px] text-center">
          {meta.currentPage} / {meta.totalPages}
        </span>
        <Button
          variant="outline"
          size="sm"
          onClick={pagination.nextPage}
          disabled={!meta.hasNextPage}
          aria-label="Next page"
          className="min-h-[44px] min-w-[44px] md:min-h-0 md:min-w-0"
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
